angular.module('aq.filters')
.filter('dateToMillis', function() {
    return function(input) {
        return moment.utc(input + ' UTC').valueOf();
    }
});